"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
import { LiveRecorder } from "../ui/LiveRecorder";
import { getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type Player = {
  name: string;
  score: string;
};
type Team = {
  name: string;
  score: string;
  wickets?: string;
  logo: string;
};
type ScoreBoardProps = {
  updateTime?: string;
  backgroundImage?: string;
  team1?: Team;
  team2?: Team;
  team1Players?: Player[];
  team2Players?: Player[];
  statusMessage?: string;
  imageMetadata?: ImageMetadata;
};
export default function ScoreCard(t0) {
  const $ = _c(81);
  const {
    updateTime: t1,
    backgroundImage: t2,
    team1: t3,
    team2: t4,
    team1Players: t5,
    team2Players: t6,
    statusMessage: t7,
    imageMetadata
  } = t0;
  const updateTime = t1 === undefined ? "10 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1 \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1" : t1;
  const backgroundImage = t2 === undefined ? "https://media.dinamani.com/dinamani/2026-02-27/uz4952pf/IplImage.png" : t2;
  let t8;
  if ($[0] !== t3) {
    t8 = t3 === undefined ? {
      name: "\u0B8E\u0BAE\u0BCD.\u0B90",
      score: "127",
      wickets: "3",
      logo: "https://media.dinamani.com/dinamani/2026-02-27/oj314nb9/Ipl1.png"
    } : t3;
    $[0] = t3;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  const team1 = t8;
  let t9;
  if ($[2] !== t4) {
    t9 = t4 === undefined ? {
      name: "\u0B95\u0BB3\u0BCD\u0B86\u0BB0\u0BCD\u0B8E\u0B9A\u0BCD",
      score: "yet to bat",
      logo: "https://media.dinamani.com/dinamani/2026-02-27/nx3x3gmf/Ipl2.png"
    } : t4;
    $[2] = t4;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  const team2 = t9;
  let t10;
  if ($[4] !== t5) {
    t10 = t5 === undefined ? [{
      name: "\u0BB5. \u0B95\u0BCB\u0BB9\u0BCD\u0BB2\u0BBF",
      score: "57 (43)"
    }, {
      name: "\u0B95. \u0BAA\u0BBF\u0BB3\u0BC6\u0B95\u0BCD\u0BB8\u0BCD",
      score: "66 (46)"
    }] : t5;
    $[4] = t5;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  const team1Players = t10;
  let t11;
  if ($[6] !== t6) {
    t11 = t6 === undefined ? [{
      name: "\u0B8E. \u0B9A\u0BBF\u0B99\u0BCD",
      score: "0/26 (3.2)"
    }, {
      name: "\u0B8E\u0BA9\u0BCD. \u0B8E\u0BB2\u0BCD\u0BA9\u0BBF\u0BB8\u0BCD",
      score: "0/35 (3.0)"
    }] : t6;
    $[6] = t6;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  const team2Players = t11;
  const statusMessage = t7 === undefined ? "\u0B95\u0BB3\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD\u0B9A\u0BCD \u0BB5\u0BC6\u0BB1\u0BCD\u0BB1\u0BBF\u0B95\u0BCD\u0B95\u0BC1 52 \u0BAA\u0BA8\u0BCD\u0BA4\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD 81 \u0BB0\u0BA9\u0BCD\u0B95\u0BB3\u0BCD \u0BA4\u0BC7\u0BB5\u0BC8" : t7;
  let t12;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className="flex"><LiveRecorder id="1" /></span>;
    $[8] = t12;
  } else {
    t12 = $[8];
  }
  let t13;
  if ($[9] !== updateTime) {
    t13 = <div className="flex items-center justify-between gap-6">{t12}<span className="text-1B1B1B text-12-tamil-700">{updateTime}</span></div>;
    $[9] = updateTime;
    $[10] = t13;
  } else {
    t13 = $[10];
  }
  let t14;
  if ($[11] !== imageMetadata) {
    t14 = getFocusPointStyle(imageMetadata);
    $[11] = imageMetadata;
    $[12] = t14;
  } else {
    t14 = $[12];
  }
  let t15;
  if ($[13] !== backgroundImage || $[14] !== t14) {
    t15 = <Image src={backgroundImage} alt="Background" fill={true} className="object-cover rounded-b-lg" style={t14} placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} />;
    $[13] = backgroundImage;
    $[14] = t14;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== team1Players) {
    t16 = team1Players.map(_temp);
    $[16] = team1Players;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] !== t16) {
    t17 = <div className="grid grid-cols-1 justify-center lg:items-end items-center">{t16}</div>;
    $[18] = t16;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  let t18;
  if ($[20] !== team1.name) {
    t18 = <span className="text-FFFFFF text-18-tamil-700 flex lg:justify-end">{team1.name}</span>;
    $[20] = team1.name;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] !== team1.score) {
    t19 = <span className="text-18-tamil-500">{team1.score}</span>;
    $[22] = team1.score;
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  let t20;
  if ($[24] !== team1.wickets) {
    t20 = team1.wickets && <><span className="text-18-tamil-500">/</span><span className="text-18-tamil-500">{team1.wickets}</span></>;
    $[24] = team1.wickets;
    $[25] = t20;
  } else {
    t20 = $[25];
  }
  let t21;
  if ($[26] !== t19 || $[27] !== t20) {
    t21 = <div className="lg:flex items-center text-FFDB59 justify-end">{t19}{t20}</div>;
    $[26] = t19;
    $[27] = t20;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] !== t18 || $[30] !== t21) {
    t22 = <div className="flex flex-col lg:items-end lg:justify-end">{t18}{t21}</div>;
    $[29] = t18;
    $[30] = t21;
    $[31] = t22;
  } else {
    t22 = $[31];
  }
  let t23;
  if ($[32] !== team1.logo || $[33] !== team1.name) {
    t23 = <div className="flex justify-start"><Image src={team1.logo} alt={team1.name} width={56} height={56} className="rounded-sm" /></div>;
    $[32] = team1.logo;
    $[33] = team1.name;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] !== t22 || $[36] !== t23) {
    t24 = <div className="lg:grid lg:grid-cols-2 justify-end flex flex-row-reverse gap-4">{t22}{t23}</div>;
    $[35] = t22;
    $[36] = t23;
    $[37] = t24;
  } else {
    t24 = $[37];
  }
  let t25;
  if ($[38] !== t17 || $[39] !== t24) {
    t25 = <div className="relative lg:grid lg:grid-cols-2 flex flex-col-reverse gap-5 justify-center lg:items-center">{t17}{t24}</div>;
    $[38] = t17;
    $[39] = t24;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  let t26;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <div className="relative grid items-center justify-start gap-2 p-5"><div className="px-2 py-1 bg-0ABDF4 text-FFFFFF rounded">VS</div></div>;
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  let t27;
  if ($[42] !== team2.logo || $[43] !== team2.name) {
    t27 = <div className="flex items-center gap-5 justify-end"><Image src={team2.logo} alt={team2.name} width={56} height={56} className="rounded-sm" /></div>;
    $[42] = team2.logo;
    $[43] = team2.name;
    $[44] = t27;
  } else {
    t27 = $[44];
  }
  let t28;
  if ($[45] !== team2.name) {
    t28 = <span className="text-FFFFFF text-18-tamil-700">{team2.name}</span>;
    $[45] = team2.name;
    $[46] = t28;
  } else {
    t28 = $[46];
  }
  let t29;
  if ($[47] !== team2.score) {
    t29 = <span className="text-18-tamil-500">{team2.score}</span>;
    $[47] = team2.score;
    $[48] = t29;
  } else {
    t29 = $[48];
  }
  let t30;
  if ($[49] !== team2.wickets) {
    t30 = team2.wickets && <><span className="text-18-tamil-500">/</span><span className="text-18-tamil-500">{team2.wickets}</span></>;
    $[49] = team2.wickets;
    $[50] = t30;
  } else {
    t30 = $[50];
  }
  let t31;
  if ($[51] !== t29 || $[52] !== t30) {
    t31 = <div className="flex items-center gap-2 text-FFDB59">{t29}{t30}</div>;
    $[51] = t29;
    $[52] = t30;
    $[53] = t31;
  } else {
    t31 = $[53];
  }
  let t32;
  if ($[54] !== t28 || $[55] !== t31) {
    t32 = <div>{t28}{t31}</div>;
    $[54] = t28;
    $[55] = t31;
    $[56] = t32;
  } else {
    t32 = $[56];
  }
  let t33;
  if ($[57] !== t27 || $[58] !== t32) {
    t33 = <div className="lg:grid lg:grid-cols-2 flex justify-start gap-4">{t27}{t32}</div>;
    $[57] = t27;
    $[58] = t32;
    $[59] = t33;
  } else {
    t33 = $[59];
  }
  let t34;
  if ($[60] !== team2Players) {
    t34 = team2Players.map(_temp2);
    $[60] = team2Players;
    $[61] = t34;
  } else {
    t34 = $[61];
  }
  let t35;
  if ($[62] !== t34) {
    t35 = <div className="lg:flex lg:flex-col">{t34}</div>;
    $[62] = t34;
    $[63] = t35;
  } else {
    t35 = $[63];
  }
  let t36;
  if ($[64] !== t33 || $[65] !== t35) {
    t36 = <div className="relative lg:flex grid grid-cols-1 gap-5 lg:justify-center lg:items-center">{t33}{t35}</div>;
    $[64] = t33;
    $[65] = t35;
    $[66] = t36;
  } else {
    t36 = $[66];
  }
  let t37;
  if ($[67] !== t25 || $[68] !== t36) {
    t37 = <div className="md:flex grid grid-cols-1 justify-between px-4">{t25}{t26}{t36}</div>;
    $[67] = t25;
    $[68] = t36;
    $[69] = t37;
  } else {
    t37 = $[69];
  }
  let t38;
  if ($[70] !== statusMessage) {
    t38 = <div className="relative flex rounded-lg items-center justify-center bg-0ABDF4 text-FFFFFF text-16-tamil-500"><div className="p-4">{statusMessage}</div></div>;
    $[70] = statusMessage;
    $[71] = t38;
  } else {
    t38 = $[71];
  }
  let t39;
  if ($[72] !== t37 || $[73] !== t38) {
    t39 = <div className="grid grid-cols-1 w-full pt-4 gap-4">{t37}{t38}</div>;
    $[72] = t37;
    $[73] = t38;
    $[74] = t39;
  } else {
    t39 = $[74];
  }
  let t40;
  if ($[75] !== t15 || $[76] !== t39) {
    t40 = <div className="relative flex mt-4 grid grid-cols-1 items-center justify-center lg:flex lg:justify-between lg:items-center gap-5">{t15}{t39}</div>;
    $[75] = t15;
    $[76] = t39;
    $[77] = t40;
  } else {
    t40 = $[77];
  }
  let t41;
  if ($[78] !== t13 || $[79] !== t40) {
    t41 = <div className="w-full text-white p-4 rounded-md lg:flex lg:flex-col ">{t13}{t40}</div>;
    $[78] = t13;
    $[79] = t40;
    $[80] = t41;
  } else {
    t41 = $[80];
  }
  return t41;
}
function _temp2(player_0, index_0) {
  return <span key={index_0} className={`text-FFFFFF text-14-tamil-600 flex ${index_0 !== 0 ? "text-D2D2D2 text-12-tamil-400" : ""}`}>{player_0.name} : {player_0.score}</span>;
}
function _temp(player, index) {
  return <span key={index} className={`text-FFFFFF text-14-tamil-600 flex ${index !== 0 ? "text-E8E8E8 text-14-tamil-400" : ""}`}>{player.name} : {player.score}</span>;
}